import React, { Component } from 'react';

import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import ImagePanel from '@components/ImagePanel/ImagePanel';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import Mobile from './Mobile/Mobile';
import Desktop from './Desktop/Desktop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImportImages from '@src/importImages';
import Helmet from 'react-helmet';

const P100 = ImportImages('/compare/p100.png');
const P300 = ImportImages('/compare/p300.png');
//const L650 = ImportImages('/compare/l650.png');
const Clouds = ImportImages('/home/clouds.jpg');
const Image = ImportImages('/compare/compare-flights.jpg');

class CompareAircraft extends Component {
  state = {
    boxs: [
      {
        id: 1,
        title: 'Range',
        content: (
          <React.Fragment>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 100
            </div>
            <div className={'pb-4 color-red asap-semibold compare-content'}>
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              1,217 NM
              <FontAwesomeIcon
                className={'ml-3 font-lg position-relative'}
                style={{ top: '3px' }}
                icon={['fas', 'plane']}
              />
              &nbsp;
            </div>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 300
            </div>
            <div className={'pb-4 color-red asap-semibold compare-content'}>
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              1,999 NM
              <FontAwesomeIcon
                className={'ml-3 font-lg position-relative'}
                style={{ top: '3px' }}
                icon={['fas', 'plane']}
              />
              &nbsp;
            </div>
            {/*<div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Legacy 650
            </div>
            <div className={'color-red asap-semibold compare-content'}>
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              <FontAwesomeIcon className={'mr-3'} icon={['fas', 'circle']} />
              3,910 NM
              <FontAwesomeIcon
                className={'ml-3 font-lg position-relative'}
                style={{ top: '3px' }}
                icon={['fas', 'plane']}
              />
              &nbsp;
            </div> */}
            <div
              className={
                'text-uppercase asap-regular color-red ls-01 font-sm pt-3'
              }
            >
              * Ranges shown for comparison purposes only. All flights are
              subject to JetSuite flight operations.
            </div>
          </React.Fragment>
        )
      },
      {
        id: 2,
        title: 'Cruise Speed',
        content: (
          <React.Fragment>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 100
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              382 Mph
            </div>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 300
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              440 Mph
            </div>
            {/*<div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Legacy 650
            </div>
            <div
              className={
                'text-uppercase color-red asap-semibold compare-content'
              }
            >
              489 Mph
            </div>*/}
          </React.Fragment>
        )
      },
      {
        id: 3,
        title: 'Passengers',
        content: (
          <React.Fragment>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 100
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              4 passengers
            </div>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 300
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              7 passengers
            </div>
            {/*<div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Legacy 650
            </div>
            <div
              className={
                'text-uppercase color-red asap-semibold compare-content'
              }
            >
              13 passengers
            </div>*/}
          </React.Fragment>
        )
      },
      {
        id: 4,
        title: 'Cabin Height',
        content: (
          <React.Fragment>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 100
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              5ft
            </div>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 300
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              5ft
            </div>
            {/*<div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Legacy 650
            </div>
            <div
              className={
                'text-uppercase color-red asap-semibold compare-content'
              }
            >
              6ft
            </div>*/}
          </React.Fragment>
        )
      },
      {
        id: 5,
        title: 'Baggage Capacity',
        content: (
          <React.Fragment>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 100
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              71ft
              <sup>3</sup>
            </div>
            <div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Phenom 300
            </div>
            <div
              className={
                'pb-4 text-uppercase color-red asap-semibold compare-content'
              }
            >
              76ft
              <sup>3</sup>
            </div>
            {/*<div className={'asap-semibold font-lg text-uppercase pt-2 pb-3'}>
              Legacy 650
            </div>
            <div
              className={
                'text-uppercase color-red asap-semibold compare-content'
              }
            >
              286ft
              <sup>3</sup>
            </div>*/}
          </React.Fragment>
        )
      },
      {
        id: 6,
        title: 'Aircraft Details',
        content: (
          <React.Fragment>
            <Row className={'justify-content-center'}>
              <Col md={6} className={'mb-4'}>
                <Link
                  to={'/our-aircraft/p100'}
                  className={
                    'd-block background-white p-3 compare-content black-link'
                  }
                >
                  <img
                    src={P100}
                    alt={'Phenom 100'}
                    className={'img-fluid d-block mx-auto'}
                    style={{ height: '50px' }}
                  />
                  <div
                    className={'text-center text-uppercase lakes-demibold pt-3'}
                    style={{ letterSpacing: '2px' }}
                  >
                    Phenom 100
                  </div>
                </Link>
              </Col>
              <Col md={6} className={'mb-4'}>
                <Link
                  to={'/our-aircraft/p300'}
                  className={
                    'd-block background-white p-3 compare-content black-link'
                  }
                >
                  <img
                    src={P300}
                    alt={'Phenom 300'}
                    className={'img-fluid d-block  mx-auto'}
                    style={{ height: '50px' }}
                  />
                  <div
                    className={'text-center text-uppercase lakes-demibold pt-3'}
                  >
                    Phenom 300
                  </div>
                </Link>
              </Col>
              {/*<Col md={6}>
                <Link
                  to={'/our-aircraft/l650'}
                  className={
                    'd-block background-white p-3 compare-content black-link'
                  }
                >
                  <img
                    src={L650}
                    alt={'Legacy 650'}
                    className={'img-fluid d-block mx-auto'}
                    style={{ height: '50px' }}
                  />
                  <div
                    className={'text-center text-uppercase lakes-demibold pt-3'}
                  >
                    Legacy 650
                  </div>
                </Link>
              </Col>*/}
            </Row>
          </React.Fragment>
        )
      }
    ],
    active: 1,
    mobileActive: 0
  };

  onClickHandler = id => {
    this.setState({
      active: id,
      mobileActive: id
    });
  };

  render() {
    let styles = {};
    let classNames = '';
    if (window.innerWidth < 992) {
      styles.minHeight = this.props.pageHeight + 'px';
      styles.backgroundImage = `url(${Clouds})`;
      styles.backgroundSize = 'auto 100%';
      styles.backgroundPosition = 'center center';
      classNames = 'pb-4 px-0';
    } else {
      styles.height = this.props.pageHeight + 'px';
      classNames = 'abs-container d-flex align-items-center';
    }

    const containerProps = {
      pageHeight: this.props.pageHeight
    };
    containerProps.autoScroll = {
      active: 1,
      delay: 1000
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>Compare Aircraft | JetSuite</title>
          <meta
            name="description"
            content={'Compare Aircraft: Phenom 100, Phenom 300, Legacy 650.'}
          />
        </Helmet>
        <ScrollContainer {...containerProps}>
          <ImagePanel
            id={'compare-aircraft-imagepanel'}
            screenHeight={this.props.pageHeight}
            image={Image}
            alt={'Compare Aircraft'}
          />
          <div
            id={'compare-aircraft-list'}
            className={'panel d-flex align-items-center'}
            style={styles}
          >
            <img
              src={Clouds}
              alt={'Clouds'}
              className={'img-fluid d-none d-md-block'}
            />
            <Container fluid={true} className={classNames}>
              {window.innerWidth < 992 ? (
                <Mobile {...this.state} click={id => this.onClickHandler(id)} />
              ) : (
                <Desktop
                  {...this.state}
                  click={id => this.onClickHandler(id)}
                  heightSm={this.props.heightSm}
                />
              )}
            </Container>
          </div>
        </ScrollContainer>
      </React.Fragment>
    );
  }
}
export default CompareAircraft;



// WEBPACK FOOTER //
// ./src/components/CompareAircraft/CompareAircraft.js